import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import {
  FormaGeneral,
  Forma,
  TablaMaestra
} from '@app/shared';

@Injectable()
export class ViewFormComponentDataService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }

  /**
   * Consulta la forma
   *
   * @param {number} idForm
   * @returns {Observable<Forma>}
   * @memberof ViewFormComponentDataService
   */
  getForm(idForm: number): Observable<Forma> {
    return new Observable(obs => {
      this.http.skipErrorHandler().get<Forma>(this.api.get('dynamicForm', [ idForm ])).subscribe(
        form => {
          form.sub_formas.forEach(subForm => {
            subForm.campos.sort((a, b) => a.orden - b.orden);
          });
          obs.next(form);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          obs.error(err);
        }
      );
    });
  }

  /**
   * Guarda o actualiza la forma
   *
   * @param {Array<FormaGeneral>} form
   * @param {boolean} [edit=false]
   * @param {number} [idForm]
   * @returns {Observable<boolean>}
   * @memberof ViewFormComponentDataService
   */
  saveForm(form: Array<FormaGeneral>, edit: boolean = false, idForm?: number, forzar_guardado?: boolean):
  Observable<boolean> {

    const forms: any = {formas: form};

    let method = 'post';
    let url = this.api.get('dynamicForm');
    if (edit) {
      method = 'put';
      forms['forzar_guardado'] = forzar_guardado;
      url = this.api.get('dynamicForm', [ idForm ]);
    }

    return new Observable(obs => {
      this.http.skipErrorHandler()[method](url, forms, {
        observe: 'response'
      }).subscribe(
        (res: any) => {
          if (res.status === 201) {
            obs.next(true);
            this.toastr.success(res.body['message'], 'Operación exitosa');
          } else {
            obs.next(false);
          }
        },
        (err: any) => {
          if (err.status !== 401 && err.status !== 403) {
            if (err.error.nombre) {
              this.toastr.error(err.error.nombre, 'Error de operacion');
            } else {
              this.toastr.error('Lo sentimos ha ocurrido un error', 'Error de operacion');
            }
          }
          obs.next(false);
        }
      );
    });
  }

  /**
   * Elimina la forma
   *
   * @param {number} idForm
   * @returns {Observable<boolean>}
   * @memberof ViewFormComponentDataService
   */
  deleteForm(idForm: number): Observable<boolean> {

    return new Observable(obs => {
      this.http.skipErrorHandler().delete(this.api.get('dynamicForm', [ idForm ]), {
        observe: 'response'
      }).subscribe(
        res => {
          if (res.status === 201) {
            obs.next(true);
            this.toastr.success(res.body['message'], 'Operación exitosa');
          } else {
            obs.next(false);
          }
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            if (err.error.id) {
              this.toastr.error(err.error.id, 'Error de operacion');
            } else {
              this.toastr.error('Lo sentimos ha ocurrido un error', 'Error de operacion');
            }
          }
          obs.next(false);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/view-form/shared/view-form-component-data.service.ts